export const CACHE_KEY_PREFIX = '@@auth0spajs@@';
export const CACHE_KEY_ID_TOKEN_SUFFIX = '@@user@@';
export class CacheKey {
    prefix;
    suffix;
    clientId;
    scope;
    audience;
    constructor(data, prefix = CACHE_KEY_PREFIX, suffix) {
        this.prefix = prefix;
        this.suffix = suffix;
        this.clientId = data.clientId;
        this.scope = data.scope;
        this.audience = data.audience;
    }
    /**
     * Converts this `CacheKey` instance into a string for use in a cache
     * @returns A string representation of the key
     */
    toKey() {
        return [this.prefix, this.clientId, this.audience, this.scope, this.suffix]
            .filter(Boolean)
            .join('::');
    }
    /**
     * Converts a cache key string into a `CacheKey` instance.
     * @param key The key to convert
     * @returns An instance of `CacheKey`
     */
    static fromKey(key) {
        const [prefix, clientId, audience, scope] = key.split('::');
        return new CacheKey({ clientId, scope, audience }, prefix);
    }
    /**
     * Utility function to build a `CacheKey` instance from a cache entry
     * @param entry The entry
     * @returns An instance of `CacheKey`
     */
    static fromCacheEntry(entry) {
        const { scope, audience, client_id: clientId } = entry;
        return new CacheKey({
            scope,
            audience,
            clientId
        });
    }
}
